const Select = ({ value, onChange, options, className = '', fieldName, label }) => (
    <label htmlFor={fieldName} className={className}>
        {label}
        <select
            className="bg-gray-light rounded-xl w-full py-3 px-5 mt-2 outline-none focus:ring-orange border-0"
            name={fieldName}
            value={value}
            onChange={onChange}
        >
            {options.map((option, i) => (
                <option key={i}>{option}</option>
            ))}
        </select>
    </label>
);

export default Select;
